// migrate from old ui library to new ui library
import { DhlTextAreaField as NewTextAreaField } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for TextAreaField component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const TextAreaField = (props) => {
  const {
    name,
    value,
    onChange,
    label,
    labelType,
    validation,
    disabled,
    ...rest
  } = props;

  // Map old props to new props
  const newProps = {
    ...rest,
    name,
    value,
    onChange,
    label,
    isDisabled: disabled,
    labelVariant: labelType,
    validation,
  };

  return <NewTextAreaField {...newProps} />;
};

TextAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelType: PropTypes.string,
  validation: PropTypes.any,
  disabled: PropTypes.bool,
};

export default TextAreaField;
